import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SHIFTGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ShiftGroup.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ShiftGroup.Code')
    .maxLength(15)
    .build(),
];

export const SHIFTGROUP_CONFIG = {
  entityName: 'ShiftGroup',
  localizationKey: 'Controlling::Entity.ShiftGroup',
  fields: SHIFTGROUP_FIELDS,
  permission: 'ControllingCalendar.ShiftGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
